/** Full service catalogue for the Services page (icons = lucide-react names). */

export const SERVICE_OFFERINGS = [
  {
    icon: "Sofa",
    title: "Interior Design & Turnkey Solutions",
    summary:
      "We create elegant, functional, and premium interior spaces with complete end-to-end execution—from concept to handover.",
    groups: [
      {
        items: [
          "Turnkey Interior Solutions",
          "Residential Interiors",
          "Commercial Interiors",
          "Corporate Office Interiors",
          "Modular Kitchens",
          "Wardrobes & Storage Solutions",
          "False Ceilings",
          "Custom Furniture",
          "Lighting Design",
          "Home Automation",
          "Renovation & Remodeling",
        ],
      },
    ],
  },
  {
    icon: "HardHat",
    title: "Construction Services",
    summary:
      "We deliver reliable construction solutions with quality workmanship and professional project management.",
    groups: [
      {
        items: [
          "Residential Construction",
          "Commercial Construction",
          "Luxury Villas",
          "Structural & Civil Works",
          "Design & Build",
          "Project Management",
        ],
      },
    ],
  },
  {
    icon: "Building2",
    title: "Real Estate Services",
    summary:
      "Helping clients buy, sell, invest, and develop properties with complete transparency.",
    groups: [
      {
        title: "Buying & Selling",
        items: [
          "Residential Properties",
          "Commercial Properties",
          "Apartments",
          "Villas",
          "Residential Plots",
          "Farm Lands",
          "Investment Properties",
        ],
      },
      {
        title: "Property Solutions",
        items: [
          "Land Acquisition",
          "Property Resale",
          "Property Investment Advisory",
          "Property Documentation Assistance",
          "Property Valuation",
          "Site Visits",
          "Property Marketing",
        ],
      },
      {
        title: "Development & Investment",
        items: [
          "Land Purchase for Development",
          "Joint Development Opportunities",
          "Property Redevelopment",
          "Investment Portfolio Management",
        ],
      },
    ],
  },
  {
    icon: "Wrench",
    title: "Maintenance Services",
    summary:
      "Ensuring your property remains in excellent condition long after project completion.",
    groups: [
      {
        items: [
          "Annual Maintenance Contracts (AMC)",
          "Residential Building Maintenance",
          "Commercial & Office Maintenance",
          "School & College Maintenance",
          "Painting & Repairs",
          "Renovation & Refurbishment",
        ],
      },
    ],
  },
  {
    icon: "Factory",
    title: "Custom Manufacturing",
    summary:
      "High-quality customized manufacturing tailored to your design requirements.",
    groups: [
      {
        items: [
          "Modular Furniture Manufacturing",
          "Veneer & PU Finish Works",
          "Glass & Metal Fabrication",
          "CNC Decorative Panels",
        ],
      },
    ],
  },
  {
    icon: "PenTool",
    title: "Design Services",
    summary:
      "Professional planning and visualization to help clients make confident decisions before execution.",
    groups: [
      {
        items: [
          "Interior Design Consultation",
          "Space Planning",
          "2D Layout Planning",
          "3D Visualization & Renders",
          "BOQ (Bill of Quantities)",
          "Cost Estimation",
          "Material Selection",
        ],
      },
    ],
  },
];

export const INDUSTRIES_WE_SERVE = [
  "Residential Projects",
  "Commercial Spaces",
  "Corporate Offices",
  "Retail Stores",
  "Hospitality",
  "Healthcare Facilities",
  "Educational Institutions",
  "Real Estate Developers",
  "Investors",
];

export const WHY_KALPAVRIKSHA = [
  {
    icon: "Layers",
    title: "Complete End-to-End Solutions",
    desc: "From property selection to construction, interiors, and maintenance—everything under one trusted brand.",
  },
  {
    icon: "Building2",
    title: "Real Estate + Construction + Interiors",
    desc: "A unique integrated approach that saves time, cost, and coordination.",
  },
  {
    icon: "KeyRound",
    title: "Design to Handover",
    desc: "Single-point responsibility from planning and execution to final delivery.",
  },
  {
    icon: "Handshake",
    title: "Property Buying & Resale Assistance",
    desc: "Expert guidance for purchasing, selling, and investing in properties.",
  },
  {
    icon: "Receipt",
    title: "Transparent Pricing",
    desc: "Detailed quotations with no hidden charges.",
  },
  {
    icon: "Gem",
    title: "Premium Quality Materials",
    desc: "We use trusted brands and high-quality materials for long-lasting results.",
  },
  {
    icon: "CalendarCheck",
    title: "On-Time Project Delivery",
    desc: "Professional planning ensures projects are completed within committed timelines.",
  },
  {
    icon: "UserCheck",
    title: "Dedicated Project Managers",
    desc: "A single point of contact to keep your project organized and stress-free.",
  },
  {
    icon: "LifeBuoy",
    title: "After-Sales Support",
    desc: "Reliable maintenance and customer support even after project completion.",
  },
];

/** Short cards for Home page — links to full Services page */
export const SERVICES = [
  {
    icon: "Sofa",
    title: "Interior Design & Turnkey",
    desc: "Premium interiors from concept to handover—residential, commercial, kitchens, automation and more.",
  },
  {
    icon: "HardHat",
    title: "Construction Services",
    desc: "Residential and commercial builds, luxury villas, civil works, design & build, and project management.",
  },
  {
    icon: "Building2",
    title: "Real Estate Services",
    desc: "Buy, sell, invest, and develop with transparent advisory, documentation, and site support.",
  },
  {
    icon: "Wrench",
    title: "Maintenance Services",
    desc: "AMC, painting, repairs, and refurbishment for homes, offices, schools, and commercial assets.",
  },
  {
    icon: "Factory",
    title: "Custom Manufacturing",
    desc: "Modular furniture, veneer & PU, glass & metal fabrication, and CNC decorative panels.",
  },
  {
    icon: "PenTool",
    title: "Design Services",
    desc: "Consultation, space planning, 3D renders, BOQ, cost estimation, and material selection.",
  },
];
